import { isMacOs } from '@atlassian/jira-common-components-keyboard-shortcuts-dialog/src/utils.tsx';

export const isCommandPaletteTrigger = (ev: KeyboardEvent) => {
	if (ev.key !== 'k') return false;
	if (isMacOs()) {
		if (!ev.metaKey) return false;
	} else if (!ev.ctrlKey) return false;
	return true;
};
